export enum ShopifySubscriptionType {
  SUPPORT_BASE = "supportBase",
  SUPPORT_AI = "aiMessageSuggestion",
  ORDER_TRACKING = "orderTracking",
  TEXT_MESSAGING = "textMessaging",
  /**
   * @deprecated, falls under CHECKOUT_OPTIMIZATION
   */
  ONE_CLICK_UPSELL = "oneClickUpsell",
  MARKETING = "marketing",
  CHECKOUT_OPTIMIZATION = "checkoutOptimization",
  SUPPORT_VOICE = "supportVoice",
  AI_EXCHANGE_AGENT = "aiExchangeAgent",
  RETURNS = "returns",
}

export interface CancelShopifySubscriptionBody {
  subscriptionType: ShopifySubscriptionType;
}
